// nice overview:
// https://grrr.tech/posts/create-dom-node-from-html-string/

// no IE11
const supportsTemplate = 'content' in document.createElement('template');

/** @type {{(*): Element, (*): Element}} */
let createElement = supportsTemplate ?
    (html) => {
        const template = document.createElement('template');
        template.innerHTML = html;

        return template.content.firstElementChild;
    } :
    (html) => {
        const div = document.createElement('div');
        div.innerHTML = html;

        return div.firstElementChild;
    };

export default createElement;
